var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 13V5L9 8m6 0l-3-3M9 17h1m4 0h1m4 0h1M4 17h1"
    }, null, -1)
  ]));
}
__name(render, "render");
const foldUp = markRaw({ name: "tabler-fold-up", render });
export {
  foldUp as default
};
//# sourceMappingURL=fold-up.js.map
